"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gutter = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
exports.Gutter = styled_components_1.styled.div `
  height: 100%;
  padding: ${(props) => (props.padding ? props.padding : props.theme.gutter)};
  @media (max-width: ${(props) => props.theme.screen.small}) {
    padding: ${(props) => (props.padding ? props.padding : "10px")};
  }
`;
//# sourceMappingURL=Gutter.js.map